export default "__VITE_ASSET__Dy6GBDTX__"